/*
    分类/属性筛选
 */

$('.filter-wrapper .filter-select-wrapper .select-list .collapse').click(function () {
    if (!$(this).parents('#ingSelect').length) {
        $(this).parents('.select-list').toggleClass('expand').siblings('.select-list').removeClass('expand').find('.collapse').text(' ');
        $(this).parents('.filter-select-wrapper').find('.value-list').css('height', '22px');

        $(this).parents('.select-list').siblings('.select-list').filter(function () {

            return $(this).attr('id') === 'sort-list' || $(this).attr('id') === 'radio-group-list';

        }).find('.value-list').css('height', '22px');
    } else {
        $(this).parents('.select-list').toggleClass('expand').siblings('.select-list').removeClass('expand').find('.collapse').text(' ');
    }

    if ($(this).parents('.select-list').hasClass('expand')) {
        $(this).html('&nbsp;');
        $(this).siblings('.list-value').find('.value-list').css('height', 'auto');
        if (!$(this).parents('#ingSelect').length)
            $(this).siblings('.list-value').find('.value-list').css('height', $(this).siblings('.list-value').find('.value-list').height() + 'px')
    } else {
        $(this).html('&nbsp;');
        if (!$(this).parents('#ingSelect').length)
            $(this).siblings('.list-value').find('.value-list').css('height', '22px');
    }
    $(this).parents('.filter-select-wrapper').find('.select-list .value-list').scrollTop(0);
    $(this).parents('.filter-select-wrapper').find('.list-value .value-list li').show();
});

$('.filter-wrapper .filter-select-wrapper .list-value .letter-list li').on('mouseenter', function () {
    $(this).toggleClass('cur').siblings().removeClass('cur');
    let $value_list = $(this).parent().siblings('.value-list')[0];
    $(this).parents('.list-value').find('.value-list').scrollTop(0);

    if (Number($(this).attr('rel')) === -1) {
        $($value_list).children('li').show();
    } else {
        $($value_list).children('li[rel="' + $(this).attr('rel') +'"]').show();
        $($value_list).children(':not(li[rel="' + $(this).attr('rel') +'"])').hide();
    }
});

$('.filter-wrapper .collapse').each(function () {
    if ($(this).css('display') === 'none') {
        let $value_list = $(this).siblings('.list-value').find('.value-list');
        if ($value_list.height() + 10 < $value_list[0].scrollHeight) {
            $(this).show()
        }
    }
});